// extracted by mini-css-extract-plugin
module.exports = {"loadingSpinner":"SitewideHeaderLogoLink_loadingSpinner___7MbZ","logoRegular":"SitewideHeaderLogoLink_logoRegular__y83ZY"};